"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { FC, useEffect, useLayoutEffect, useState } from "react";
import { useRef } from "react";

import useMediaQuery from "@/hooks/useMediaQuery";
import { BentoListProps } from "@/types";

import BentoBlock from "./BentoBlock";
import "./bentoList.css";

const BentoList: FC<BentoListProps> = ({ entry }) => {
  const [delta, setDelta] = useState(0);
  const targetRef = useRef<HTMLDivElement>(null);
  const gridRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const isMobile = useMediaQuery("(max-width: 1023px)");
  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

  let x = useTransform(scrollYProgress, [0, 1], ["0", `${delta}px`]);

  useEffect(() => {
    if (gridRef.current && containerRef.current) {
      if (isMobile) {
        const d = containerRef.current.getBoundingClientRect().width - gridRef.current.getBoundingClientRect().width;
        setDelta(d);
      }
    }
  }, [gridRef, containerRef, isMobile]);

  useLayoutEffect(() => {
    const updateSize = () => {
      if (gridRef.current && containerRef.current) {
        if (isMobile) {
          const d = containerRef.current.getBoundingClientRect().width - gridRef.current.getBoundingClientRect().width;
          setDelta(d);
        }
      }
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, [gridRef, containerRef, isMobile]);

  return (
    <div
      ref={targetRef}
      style={{ height: isMobile ? `${entry.modules.length * 100}vh` : "auto" }}
      className={`delta-${delta} pb-xl bentolist-container`}
    >
      <div className={`${isMobile ? "sticky" : ""} top-0 overflow-hidden`}>
        <div ref={containerRef} className="relative w-22\/24 md:w-20\/24 mx-auto">
          {entry.title && (
            <div className="w-full pt-xxl pb-l">
              <h2 className="font font-primary uppercase text-l md:text-xl text-center font-normal leading-5 md:leading-10 tracking-widest">
                {entry.title}
              </h2>
            </div>
          )}
          {entry.subtitle && (
            <div>
              <p className="font-secondary text-[14px] font-secondary-light leading-5 text-center mb-[40px]">{entry.subtitle}</p>
            </div>
          )}
          <div className="flex md:grid">
            <motion.div ref={gridRef} style={isMobile ? { x } : {}} className="flex md:grid md:grid-cols-2 gap-xs md:gap-x-l">
              {entry.modules.map((block, i: number) => {
                return <BentoBlock key={i} block={block} />;
              })}
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BentoList;
